<template>
  <span class="pointer" @mouseover="hovering = true" @mouseleave="hovering = false">
    <slot />
    <i :class="['zmdi', hovering ? 'zmdi-edit' : placeholderIcon]"></i>
  </span>
</template>

<script>
export default {
  props: {
    placeholderIcon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hovering: false,
    }
  },
}
</script>

<style scoped>
i {
  margin-left: 6px;
}
</style>
